import { defineComponent as _defineComponent } from 'vue'
import MailChecker from 'mailchecker'



export default /*#__PURE__*/_defineComponent({
  __name: 'EmailInput',
  emits: ['validate'],
  setup(__props, { expose, emit }) {
  expose();



const checkEmail = (e) => {
  const result = MailChecker.isValid(e.target.value)
  emit('validate', result)
}

const __returned__ = { emit, checkEmail, MailChecker }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})